import * as React from 'react'
import { RouteComponentProps } from 'react-router'

type Props = RouteComponentProps<{}>

export default class Tracking extends React.Component<Props> {
  componentDidMount() {
    this.trackPageview()
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.trackPageview()
    }
  }

  render() {
    return null
  }

  private trackPageview() {
    window.ga('set', 'page', location.pathname)
    window.ga('send', 'pageview')
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Tracking.ts